import {Injectable} from '@angular/core';
import {BaseEndpointService} from '../base-endpoint-service';
import {Backend} from '@generated-backend-types';
import {ListItem} from "src/app/entities/list-item.entity";
import {ActivatedRouteSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import Process = Backend.App.Resources.Dashboard.QualityManagement.Process;
import SubProcess = Backend.App.Resources.Dashboard.QualityManagement.SubProcess;
import SubProcessPivotData = Backend.App.Data.Dashboard.QualityManagement.SubProcessPivotData;

@Injectable({providedIn: 'root'})
export class SubProcessService extends BaseEndpointService<SubProcess, SubProcessPivotData> {
  public override resolve(route: ActivatedRouteSnapshot): Observable<SubProcess> {
    const process = route.parent?.data['process'];
    if (process) this.forProcess(process);
    return this.get(route.params['id']).pipe(map(r => r.data));
  }

  public forProcess(process: Process) {
    this.endpoint = `/quality-management/processes/${process.id}/sub-processes`;
  }

  public override modelToMultiSelectItem(m: SubProcess): ListItem & { model: SubProcess; } {
    return {
      id: m.id,
      text: m.process_title ?? m.process_ext_id,
      isDisabled: false,
      model: m,
    }
  }
}
